'use strict';

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union
 */
module.exports = {
  union: require('./union'),
  derivations: require('./derivations')
};


//////////////////
// WEBPACK FOOTER
// ./~/folktale/adt/union/index.js
// module id = 99
// module chunks = 34471704633725 35783957827783 216468464745311